import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2 className='text-center'><b>COMMING SOON.....</b></h2>
        </div>
    );
};

export default Blog;